import React, { useState } from "react";
import { FaLock, FaClipboardList, FaMinus, FaPlus, FaFileMedical, FaShieldAlt, FaChartBar, FaSyncAlt, FaUserCheck, FaExchangeAlt, FaHeartbeat,FaChartPie, FaMoneyCheckAlt, FaFileInvoiceDollar,} from "react-icons/fa";

import {  FaUserShield, FaHandshake,} from "react-icons/fa";
import Medpalm from "../../../assests/service/payer.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
      "title": "Healthcare Interoperability Strategy Development",
      "description": 
          "Develop a robust strategy to enhance healthcare data exchange across different systems, enabling seamless communication between hospitals, clinics, insurers, and third-party applications. This strategy focuses on accelerating client onboarding, reducing integration costs, ensuring HIPAA compliance, and aligning with industry standards like FHIR and HL7. By implementing a structured interoperability framework, healthcare organizations can improve operational efficiency, reduce errors, and provide better patient outcomes."
    },
    {
      "title": "Healthcare Interoperability Roadmapping",
      "description": 
          "Create a structured and actionable roadmap to guide healthcare organizations toward achieving interoperability goals. This includes defining clear milestones, selecting appropriate technologies, and outlining implementation best practices. The roadmap ensures compliance with regulatory requirements, mitigates risks, and facilitates seamless integration of Electronic Health Records (EHRs), patient management systems, and third-party applications for enhanced data accessibility."
    },
    {
      "title": "Healthcare Data Mapping & Workflow Documentation",
      "description": 
          "Establish structured data mapping frameworks to standardize and optimize the exchange of healthcare data between multiple platforms. This process involves converting disparate data formats into a unified structure, eliminating inconsistencies, and improving accessibility for healthcare providers. Comprehensive workflow documentation helps streamline data flow, minimize integration challenges, and enhance clinical and administrative efficiency across healthcare systems."
    },
    {
      "title": "Healthcare Interoperability Training & Education",
      "description": 
          "Provide specialized training programs for healthcare professionals, IT teams, and administrative staff to enhance their understanding of interoperability standards like HL7, FHIR, and DICOM. Training covers best practices for data security, regulatory compliance, and implementation strategies to ensure seamless system integrations. By equipping teams with the necessary expertise, organizations can effectively adopt interoperability solutions and maintain long-term data connectivity."
    },
    {
      "title": "EHR Integration Planning",
      "description": 
          "Develop a strategic plan for integrating Electronic Health Record (EHR) systems with various healthcare platforms, including laboratory information systems, radiology systems, and telemedicine solutions. The integration planning process ensures secure, scalable, and efficient data exchange while adhering to industry standards such as FHIR and HL7. A well-structured EHR integration improves workflow automation, enhances patient data accuracy, and enables a unified health information ecosystem."
    }
  ]
  
const features = [
    { icon: <FaExchangeAlt />, text: "Seamless health record transfer between insurance providers." },
    { icon: <FaShieldAlt />, text: "Ensures compliance with CMS and data privacy laws." },
    { icon: <FaFileMedical />, text: "Standardized exchange of claims, authorizations, and history." },
    { icon: <FaFileInvoiceDollar />, text: "Faster claim approvals and reimbursement processing." },
    { icon: <FaUserCheck />, text: "Real-time verification of patient coverage and benefits." },
    { icon: <FaLock />, text: "Secure, encrypted data transfers to prevent breaches." },
    { icon: <FaSyncAlt />, text: "Automated updates across different payer networks." },
    { icon: <FaChartBar />, text: "Analytics-driven fraud detection and policy optimization." }
];

const benefits = [
    { text: "Effortless data sharing between payers.", icon: <FaExchangeAlt className="text-[#2a627a] text-2xl" /> },
    { text: "Smooth patient data transfer across insurers.", icon: <FaSyncAlt className="text-[#2a627a] text-2xl" /> },
    { text: "Faster claim approvals and reduced delays.", icon: <FaFileInvoiceDollar className="text-[#2a627a] text-2xl" /> },
    { text: "Stronger data security and compliance.", icon: <FaUserShield className="text-[#2a627a] text-2xl" /> },
    { text: "Better decision-making with complete records.", icon: <FaChartPie className="text-[#2a627a] text-2xl" /> },
    { text: "Enhanced patient experience with seamless coverage transitions.", icon: <FaUserCheck className="text-[#2a627a] text-2xl" /> },
]    

const consentItems = [
    { icon: <FaMoneyCheckAlt />, text: "Manage healthcare financing and reimburse providers for medical services." },
    { icon: <FaUserShield />, text: "Ensure compliance with regulations like HIPAA and streamline data security." },
    { icon: <FaFileInvoiceDollar />, text: "Process claims efficiently to reduce delays in provider payments." },
    { icon: <FaChartPie />, text: "Analyze healthcare costs and optimize reimbursement models." },
    { icon: <FaClipboardList />, text: "Define coverage policies and determine benefit structures for members." },
    { icon: <FaHandshake />, text: "Collaborate with providers to enhance patient care and cost transparency." },
    { icon: <FaHeartbeat />, text: "Support value-based care models by incentivizing quality treatment." },
    { icon: <FaSyncAlt />, text: "Enable seamless data exchange with providers and other payers for better coordination." }
];

const Payer = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
        <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
            {/* Header Section */}
            <div className=" text-center w-full">
                <h1 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 "> Payer-to-Payer  </h1>
                <p className="text-gray-800 mt-3 text-sm">
                Ensures regulatory compliance while allowing health insurers to exchange patient data efficiently, reducing administrative burden and enhancing care coordination.
                </p>
            </div>

            {/* What is Interoperability? */}
            <section className="mt-8 flex flex-col md:flex-row bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                <img draggable={false}src={Medpalm} alt="Payer to payer Healthcare" className="rounded-2xl hover:shadow-2xl w-full md:w-1/5" />
                <div className="md:ml-6 mt-2 md:mt-0">
                    <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Payer-to-payer?</h2>
                    <p className="text-gray-800 mt-2 text-sm text-wrap">
                    Payer-to-Payer data exchange is the process of securely transferring patient health information between different health insurance providers (payers). This ensures continuity of care, improves efficiency, and reduces administrative burdens when a patient switches insurance plans.
                    </p>
                </div>
            </section>


            {/* Role of Interoperability */}
            <section className="mt-8 w-full">
                <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 ">
                    Role of Interoperability
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                    {consentItems.map((item, index) => (
                        <motion.div
                            key={index}
                            className="relative z-10 bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
                            initial={{ opacity: 0, x: -100 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 1 }}
                        >
                            <span className="text-[#2a627a] text-lg">{item.icon}</span>
                            <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                        </motion.div>
                    ))}
                </div>
            </section>

            {/* Key Features Section */}
            <section className="mt-6 w-full">
                <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 ">
                    Key Features
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                    {features.map((item, index) => (
                        <motion.div
                            key={index}
                            className="relative bg-gray-300 bg-opacity-70 hover:bg-gray-300 text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl flex flex-col items-center text-center"
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: -10 }}
                            transition={{ duration: 1 }}
                        // viewport={{ once: true }}
                        >
                            {item.icon}
                            <span className="text-gray-800 text-sm font-medium mt-3">{item.text}</span>
                        </motion.div>
                    ))}
                </div>
            </section>

            {/* Benefits Section */}
            <section className="mt-8 w-full">
                <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                    Benefits
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                    {benefits.map((item, index) => (
                        <motion.div
                            key={index}
                            className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                            initial={{ opacity: 0, scale: 0.8, y: 40 }}
                            whileInView={{ opacity: 1, scale: 1, y: 0 }}
                            transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                            viewport={{ once: false, amount: 0.3 }}>
                            {item.icon}
                            <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                        </motion.div>
                    ))}
                </div>
            </section>




            {/* Services Section */}
            <section className="mt-12 w-full  mx-auto">
                {/* Heading */}
                <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                    Discover Our Services
                </h2>

                {/* Service List */}
                <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                    {services.map((service, index) => (
                        <div key={index} className="border-b border-gray-800">
                            {/* Service Title */}
                            <button
                                className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                            >
                                {service.title}
                                {openIndex === index ? (
                                    <FaMinus className="text-red-500" />
                                ) : (
                                    <FaPlus className="text-gray-600" />
                                )}
                            </button>

                            {/* Service Description (Expandable with Animation) */}
                            <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                transition={{ duration: 0.3, ease: "easeInOut" }}
                                className="overflow-hidden"
                            >
                                <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                            </motion.div>
                        </div>
                    ))}
                </div>
            </section>

        </div>
        <Footer/>
        </>
    );
};

export default Payer;
